class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content =
      this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      'focusout',
      this.onFocusOut.bind(this)
    );

    this.mainDetailsToggle.addEventListener(
      'toggle',
      this.onToggle.bind(this)
    );
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }

  onToggle() {
    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    this.animations.forEach((animation) => {
      if (this.mainDetailsToggle.open) {
        animation.play();
      } else {
        animation.cancel();
      }
    });
  }

  close() {
    this.mainDetailsToggle.open = false;
    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', 'false');
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    const desktopHover = window.matchMedia(
      '(min-width: 990px) and (hover: hover) and (pointer: fine)'
    );

    this.addEventListener('pointerenter', () => {
      if (!desktopHover.matches) return;

      clearTimeout(this.menuCloseTimer);
      this.closeOtherMenus();

      this.mainDetailsToggle.open = true;
      this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', 'true');
    });

    this.addEventListener('pointerleave', () => {
      if (!desktopHover.matches) return;

      clearTimeout(this.menuCloseTimer);

      this.menuCloseTimer = setTimeout(() => {
        this.close();
      }, 300);
    });
  }

  closeOtherMenus() {
    const navigation = this.closest('.header__inline-menu');
    if (!navigation) return;

    navigation.querySelectorAll('header-menu').forEach((menu) => {
      if (menu === this) return;

      clearTimeout(menu.menuCloseTimer);
      menu.close();
    });
  }

  onToggle() {
    if (this.mainDetailsToggle.open) {
      this.closeOtherMenus();
    }

    this.mainDetailsToggle
      .querySelector('summary')
      .setAttribute(
        'aria-expanded',
        String(this.mainDetailsToggle.open)
      );

    if (!this.header) return;

    this.header.preventHide = Boolean(
      this.header.querySelector('header-menu > details[open]')
    );

    if (
      document.documentElement.style.getPropertyValue(
        '--header-bottom-position-desktop'
      ) !== ''
    ) return;

    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
